<template>
    <div class='news-wrapper'>
        <div class='right-content scroll' ref='articlceWrap'>
            <Article ref='newsContent' />
        </div>
    </div>
</template>

<script>
//单页类型未初始化过，可使用  http://software.myhexin.com/gitlab/website/pcclient-singlePage 这个页面；
import Article from '@/pages/components/article';
import * as actions from '@/common/js/api'
export default {
    name: 'news',
    data() {
        return {
            selectArticle: {},
            title: '',
        }
    },
    provide() {
        return { pageDetail: { ...this.model } }
    },
    props: ['model'],
    components: {
        Article
    },
    computed: {
        hasLeft() {
            return this.model.treeid
        }
    },
    beforeCreate: function () {
    },
    created: function () {
        this.$nextTick(_ => {
            this.$refs.newsContent.initData({ seq: this.model.seq })
        })

    },
    watch: {
        title: {
            handler(val) {
                this.takeThingsBack(this.title)
            }
        }
    },
    mounted: function () {
    },
    methods: {
        handleSelectChange(e) {
            this.$refs.newsContent.initData(e);
        },
        // 向外部边框传递信息
        takeThingsBack(title, collectInfo) {
            this.$dispatch('basic', 'LISTEN_CHILD', {
                method: 'freshBaseInfo',
                data: {
                    componentName: this.model.componentName,
                    collectInfo,
                    title
                }
            })
        }
    }
}
</script>
<style lang="less" scoped>
.news-wrapper {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    padding: 10px 6px 10px 10px;
    .right-content {
        overflow: hidden;
        width: 80%;
        margin: 0 auto;
        padding-right: 24px;
        padding-left: 24px;
        height: calc(100% - 40px);
    }
}
</style>
